/**
 * Custom media queries
 */
const bkptVal = {
  xl: 80, // 1280px
  lg: 64, // 1024px
  md: 48, // 768px
  sm: 32, // 512px
};

module.exports = bkptVal;

module.exports = {
  // Desktop
  '--xlMin': `(min-width: ${bkptVal.xl}rem)`,
  '--xlMax': `(max-width: ${bkptVal.xl - 0.001}rem)`,
  '--xlVal': `${bkptVal.xl}rem`,

  // Desktop / Tablet Landscape
  '--lgMin': `(min-width: ${bkptVal.lg}rem)`,
  '--lgMax': `(max-width: ${bkptVal.lg - 0.001}rem)`,
  '--lgVal': `${bkptVal.lg}rem`,

  // Tablet Portrait
  '--mdMin': `(min-width: ${bkptVal.md}rem)`,
  '--mdMax': `(max-width: ${bkptVal.md - 0.001}rem)`,
  '--mdVal': `${bkptVal.md}rem`,

  // Mobile
  '--smMin': `(min-width: ${bkptVal.sm}rem)`,
  '--smMax': `(max-width: ${bkptVal.sm - 0.001}rem)`,
  '--smVal': `${bkptVal.sm}rem`,
};
